<template>
    <div>
        <v-container fluid>
            <v-row no-gutters>
                <v-col :cols="12">
                    <h1 class="headline font-weight-light mb-3">
                        SRFR Product
                    </h1>
                </v-col>
            </v-row>
        </v-container>

        <!-- v-dialog ให้มองว่าเป็น Modal ของ Bt -->
        <v-dialog v-model="dialog" max-width="1000px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                    v-model="editedItem.product_no"
                                    label="Product no"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                    v-model="editedItem.product_description"
                                    label="Product desc"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                    v-model="editedItem.box_size"
                                    label="Box Size"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                    v-model="editedItem.weight"
                                    label="Weight"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close"
                        >Cancel</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-card>
            <v-card-title>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark class="mb-2" @click="newItem()"
                    >Create New</v-btn
                >
            </v-card-title>

            <v-data-table
                :headers="headers"
                :items="this.data"
                :items-per-page="10"
                :loading="isLoading"
                :search="search"
                loading-text="Loading... Please wait"
            >
                <!-- <template v-slot:[`item.no`]="{ item }">
                    {{ item.no }}.xxxx
                </template> -->
                <!-- <template v-slot:item.no="">{{ no }}.</template> -->
                <template v-slot:[`item.action`]="{ item }">
                    <!-- <template v-slot:item.action="{ item }"> -->
                    <v-icon small class="mr-2" @click="editItem(item)">
                        mdi-square-edit-outline
                    </v-icon>
                    <v-icon small @click="deleteItem(item)">
                        mdi-delete
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
export default {
    computed: {
        ...mapState(["isLoading"]),
        formTitle() {
            return this.editedIndex === -1
                ? "New SRFR Product"
                : "Edit SRFR Product"
        },
    },
    mounted() {
        //เปิดหน้านี้ครั้งแรก จะเข้ามาทำที่ mounted ก่อนเป็นอัมดับแรก
        this.getAjax() // เรียกฟังชั้น getAjax
    },
    data() {
        return {
            no: 1,
            search: "",
            data: [],
            dialog: false,
            editedIndex: -1,
            editedItem: {
                product_no: "",
                product_description: "",
                box_size: "",
                weight: "",
            },
            defaultItem: {
                product_no: "",
                product_description: "",
                box_size: "",
                weight: "",
            },
            url: process.env.VUE_APP_ROOT_API,
            headers: [
                // {
                //     text: "#",
                //     value: "no",
                //     class: "text-uppercase blue darken-3 white--text",
                // },
                {
                    text: "partner no",
                    value: "product_no",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "produc desc",
                    value: "product_description",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "box size",
                    value: "box_size",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "weight",
                    value: "weight",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "action",
                    value: "action",
                    class: "text-uppercase blue darken-3 white--text",
                    sortable: false,
                },
            ],
        }
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        resetEdited() {
            this.editedItem = this.defaultItem
            this.editedIndex = -1
        },
        newItem() {
            this.editedItem = {
                product_no: "",
                product_description: "",
                box_size: "",
                weight: "",
            }
            ;(this.defaultItem = {
                product_no: "",
                product_description: "",
                box_size: "",
                weight: "",
            }),
                this.resetEdited()
            this.dialog = true
        },
        editItem(item) {
            this.editedIndex = item.partner_id
            item.status = item.status == 1 ? true : false
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },
        async deleteItem(item) {
            const idx = item.product_id
            // console.log(idx)
            if (confirm("Are you sure you want to delete this SRFR Product?")) {
                const url = `${process.env.VUE_APP_ROOT_API}/api/scrap-products/delete`
                try {
                    const { data } = await axios.get(url + "/" + idx)
                } catch (error) {
                    console.log(error)
                }
                this.getAjax()
            }
        },
        close() {
            this.dialog = false
            setTimeout(() => {
                this.resetEdited()
            }, 300)
        },
        save() {
            this.editedItem.status = this.editedItem.status === true ? 1 : 0
            // console.log(this.editedItem.status, "-this.editedItem.status")
            this.sendAjax(this.editedItem, this.editedIndex)
            this.close()
        },
        async sendAjax(item, idx) {
            // console.log(item.product_id, "-item")
            const url = `${process.env.VUE_APP_ROOT_API}/api/scrap-products/`
            if (item.product_id == undefined) {
                try {
                    const { data } = await axios.post(url + "save", item)
                } catch (error) {
                    console.log(error)
                }
            } else {
                try {
                    const { data } = await axios.post(
                        url + "update/" + item.product_id,
                        item
                    )
                } catch (error) {
                    console.log(error)
                }
            }
            this.getAjax()
        },
        async getAjax() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/scrap-products/view`
            // const url = `${process.env.VUE_APP_ROOT_API}/api/partners`
            try {
                this.mutateIsLoading()
                const { data } = await axios.get(url)
                this.data = data
                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>
